module.exports = __webpack_public_path__ + "img/04.591234f8.png";